import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/core";
import { useSearchParams } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Info from "@material-ui/icons/Info";

import { formatAnniversaryDate, formatDate } from "@/utils";
import { ApiTablePagine } from "@/components/ApiTablePagine";
import ExportPolicesBtn from "@/components/ExportPolicesBtn";
import { FiltersPayloads, SortPayload } from "@/types/ApiResponse";
import { Police } from "@/types/Police";
import policyApi from "@/api/policyApi";

const MrhPolices = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();

  const typePolice = ["H"];

  useEffect(() => {
    if (!searchParams.get("filters") && !searchParams.get("sort")) {
      setSearchParams({
        sort: `key:dateEffet;direction:DESCENDING`,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getContractsMrh = (
    filters: FiltersPayloads,
    sort: SortPayload,
    currentPage: number,
    rowsPerPage: number
  ) =>
    policyApi.getPolicesFiltrees(typePolice, {
      page: currentPage,
      tri: sort,
      filtres: filters,
      size: rowsPerPage,
    });

  const getAdresse = (police: Police) =>
    [police.adresse1 ?? "-", police.adresse2, police.codePostal, police.ville]
      .filter(Boolean)
      .join(", ");

  const getStatus = (police: Police) => {
    if (police.resilie) {
      if (police.dateResil) {
        return new Date(police.dateResil) > new Date()
          ? t("dashboard.police.resilieFutur") +
              formatDate(police.dateResil, "DD/MM/YYYY")
          : t("dashboard.police.resilieLe") +
              formatDate(police.dateResil, "DD/MM/YYYY");
      }
      return t("dashboard.police.resilie");
    }
    return t("dashboard.police.enCours");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <ExportPolicesBtn typePolice={typePolice} />
      <ApiTablePagine<Police>
        key={searchParams.toString()}
        getData={getContractsMrh}
        dataId="policyNumber"
        dataStructure={[
          {
            renderer: (e) => e.numeroImmeuble,
            label: t("dashboard.police.numeroImmeuble"),
            filter: {
              key: "numeroImmeuble",
              rowType: "number",
              nullable: true,
            },
            align: "left",
          },
          {
            renderer: (e) => e.bail,
            label: t("dashboard.police.bail"),
            filter: { key: "bail", rowType: "number" },
          },
          {
            renderer: (e) => e.policyNumber,
            label: t("dashboard.police.contrat"),
            filter: { key: "policyNumber", rowType: "string" },
            align: "left",
          },
          {
            renderer: getAdresse,
            label: t("dashboard.police.adresse"),
            /*filter: [
              {
                label: t("dashboard.police.adresse"),
                key: "policyKey",
                rowType: "string",
              },
              {
                label: t("dashboard.police.ville"),
                key: "ville",
                rowType: "string",
              },
              {
                label: t("dashboard.police.codePostal"),
                key: "codePostal",
                rowType: "string",
              },
            ],*/
            align: "left",
            size: "m",
          },

          {
            renderer: (e) => formatDate(e.startDate, "DD/MM/YYYY"),
            label: t("dashboard.police.dateEffet"),
            sortKey: "dateEffet",
          },
          {
            renderer: (e) => formatAnniversaryDate(e.contractAnniversaryDate),
            label: t("dashboard.police.echeance"),
          },
          {
            renderer: (e) => getStatus(e),
            label: <StatutTooltip />,
          },
        ]}
      />
    </div>
  );
};

const StatutTooltip: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  const CustomTooltip = withStyles(() => ({
    tooltip: {
      backgroundColor: theme.palette.secondary.main,
      color: "white",
      fontSize: 12,
    },
  }))(Tooltip);

  return (
    <>
      {t("dashboard.police.statut")}{" "}
      <CustomTooltip title={t("dashboard.police.statutTooltip")}>
        <Info style={{ fontSize: 18, margin: -5, marginLeft: 5 }} />
      </CustomTooltip>
    </>
  );
};

export default MrhPolices;
